var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLupka(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#00229A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5781 30.8594L28.3594 26.6406C29.3086 25.2344 29.8008 23.4766 29.5547 21.5781C29.0977 18.3438 26.4609 15.7422 23.2617 15.3203C18.4453 14.7227 14.4375 18.7305 15.0352 23.5469C15.457 26.7461 18.0586 29.3828 21.293 29.8047C23.1914 30.0859 24.9492 29.5938 26.3906 28.6445L30.5742 32.8633C31.1367 33.3906 32.0156 33.3906 32.5781 32.8633C33.1055 32.3008 33.1055 31.4219 32.5781 30.8594ZM25.125 23.4062H23.1211V25.375C23.1211 25.8672 22.7344 26.2188 22.3125 26.2188C21.8203 26.2188 21.4688 25.8672 21.4688 25.375V23.4062H19.4648C19.0078 23.4062 18.6562 23.0547 18.6562 22.5625C18.6562 22.1055 19.0078 21.7188 19.4648 21.7188H21.4688V19.75C21.4688 19.293 21.8203 18.9062 22.2773 18.9062C22.6992 18.9062 23.1211 19.293 23.1211 19.75V21.7188H25.0898C25.582 21.7188 25.9688 22.1055 25.9688 22.5625C25.9688 23.0547 25.582 23.4062 25.125 23.4062Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupka);
export default __webpack_public_path__ + "static/media/lupka.3a976a042338893ba9b11d6f07c316a2.svg";
export { ForwardRef as ReactComponent };